import { gql } from '@apollo/client';

export default gql`
  fragment MagentoProductPriceFragment on Magento2_PriceRange {
    minimumPrice {
      regularPrice {
        value
        currency
      }
      finalPrice {
        value
        currency
      }
      discount {
        amountOff
        percentOff
      }
    }
  }

  query PricingPageShopProduct($sku: String!) {
    magento2 {
      products(filter: { sku: { eq: $sku } }) {
        items {
          __typename
          uid
          releaseDate
          detailPage
          ... on Magento2_BundleProduct {
            sdbsId
            name
            itemType
            sku
            releaseDate
            image {
              url
              label
            }
            items {
              options {
                uid
              }
            }
            stockStatus
            priceRange {
              ...MagentoProductPriceFragment
            }
          }
          ... on Magento2_VirtualProduct {
            name
            sku
            releaseDate
            image {
              url
              label
            }
            stockStatus
            priceRange {
              ...MagentoProductPriceFragment
            }
          }
          ... on Magento2_ConfigurableProduct {
            configurableOptions {
              uid
              label
              position
              attributeCode
              values {
                uid
                label
              }
            }
            variants {
              product {
                uid
                name
                sku
                sdbsId
                itemType
                categories {
                  name
                }
                hideQualifyMessage
                releaseDate
                isDefaultWithinAllVariants
                image {
                  url
                  label
                }
                stockStatus
                priceRange {
                  ...MagentoProductPriceFragment
                }
                additionalInfo
              }
              attributes {
                uid
                label
                code
                adminLabel
              }
            }
          }
        }
      }
    }
  }
`;
